import { type MouseEvent, forwardRef } from "react";

type Props = {
  className?: string;
  onClick?: (e: MouseEvent) => void;
};
export const HomeIcon = forwardRef<SVGSVGElement, Props>(({ className, onClick }, ref) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    className={className}
    onClick={onClick}
    ref={ref}
  >
    <path
      d="M2 7.91421V14.25C2 14.3881 2.11193 14.5 2.25 14.5H6C6.13807 14.5 6.25 14.3881 6.25 14.25V10C6.25 9.72386 6.47386 9.5 6.75 9.5H9.25C9.52614 9.5 9.75 9.72386 9.75 10V14.25C9.75 14.3881 9.86193 14.5 10 14.5H13.75C13.8881 14.5 14 14.3881 14 14.25V7.91421C14 7.649 13.8946 7.39464 13.7071 7.20711L8.70711 2.20711C8.31658 1.81658 7.68342 1.81658 7.29289 2.20711L2.29289 7.20711C2.10536 7.39464 2 7.649 2 7.91421Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
));
